import React from 'react'
import isPropValid from '@emotion/is-prop-valid'
import { ShouldForwardProp, StyleSheetManager } from 'styled-components'

// styled-components 6 passes every prop through to what it renders. Version 5 passed only valid HTML attributes to
// DOM elements, and every prop to components; this keeps that, so props such as textStyle, size or mb do not end up
// as DOM attributes, and wrapped components (styled(Button)) still receive variant, icon and so on.
const shouldForwardProp: ShouldForwardProp<'web'> = (prop, target) => (typeof target === 'string' ? isPropValid(prop) : true)

// Version 6 also stopped adding vendor prefixes by default; they are kept so the generated CSS is unchanged
const StyledComponentsConfig = ({ children }: { children: React.ReactNode }) => (
  <StyleSheetManager shouldForwardProp={shouldForwardProp} enableVendorPrefixes>
    {children}
  </StyleSheetManager>
)

export default StyledComponentsConfig
